module.exports = __webpack_public_path__ + "media/components/VendingCart/assets/extensions-thumbnail/6-display-0862df3df22a7512fbf45ae2797577d7.png";